<template>
    <div class="list-item">
        <div class="list-item-head">
            <div class="list-item-col1">
                <div class="list-item-accreds">
                    <span v-for="accred in accredSummary" :key="accred" class="loz loz--ghost">
                        {{ accred }}
                    </span>
                </div>

                <h2 class="h4">{{ item.firstName }} {{ item.lastName }}</h2>
            </div>

            <button @click="open = !open">
                <svg class="icon">
                    <use v-if="open" xlink:href="#minus-solid" />
                    <use v-else xlink:href="#plus-outline" />
                </svg>
            </button>
        </div>

        <div v-if="open" class="list-item-details">
            <div>
                <h6 class="h6">Location</h6>
                <p>{{ item.location || '-' }}</p>
            </div>

            <div>
                <h6 class="h6">Telephone</h6>
                <p>
                    <a :href="`tel:${item.phone}`">{{ item.phone || '-' }}</a>
                </p>
            </div>

            <div class="list-item-full-col">
                <h6 class="h6">Business Name</h6>
                <p>{{ item.business || '-' }}</p>
            </div>

            <div class="list-item-full-col">
                <h6 class="h6">Accreditation</h6>
                <template v-for="type in item.accreditationList">
                    <span :key="type.type" class="loz loz--ghost">{{ type.type }}</span>
                    <p v-for="accred in type.accreditations" :key="accred">{{ accred }}</p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        join(array) {
            return array.join(', ');
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            open: false
        };
    },

    computed: {
        accredSummary() {
            const accreds = this.item.accreditations;
            const first2 = accreds.slice(0, 2);
            if (accreds.length > 2) first2.push(`+${accreds.length - 2}`);
            return first2;
        }
    }
};
</script>

<style lang="scss" scoped>
.list-item {
    padding: 1em 0;
    border: 2px solid #e9e9e9;
    background-color: #ffffff;
    border-radius: 2px;
    margin-bottom: 1em;
    box-shadow: 0 1px 5px #e9e9e9;

    @media screen and (min-width: 769px) {
        padding: 2em 1em;
    }
}

.list-item-head {
    display: flex;
    align-items: center;
    padding: 0 1em;

    .h4 {
        margin-right: 2em;
    }

    button {
        display: block;
        height: 30px;
        line-height: 30px;
        font-size: 30px;
        margin-left: auto;
        outline: none;
    }
}

.list-item-col1 {
    @media screen and (min-width: 769px) {
        display: flex;
        align-items: center;
    }
}

.list-item-accreds {
    display: flex;
    align-items: center;
    margin-bottom: 0.5em;

    @media screen and (min-width: 769px) {
        width: 350px;
        margin-bottom: 0;
    }

    img {
        height: 100%;
        object-fit: contain;
        object-position: center;
    }
}

.list-item-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2em;
    margin: 2em 1.25em 1em;
    font-size: 16px;

    @media screen and (min-width: 769px) {
        margin: 1em 0 3em 368px;
    }

    .h6 {
        margin-bottom: 0.5em;
    }

    a {
        color: #ef6e0b;
    }
}

.list-item-full-col {
    grid-column: span 2;

    p + span {
        margin-top: 1.5em;
    }
}

.loz {
    margin: 5px 5px 5px 0;
    line-height: 22px;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 12px;

    @media screen and (min-width: 769px) {
        font-size: 13px;
    }
}

/* .item {
    padding: 1em;
    border: 1px solid #eee;
    margin: 0.5em 1em;
}

.label {
    display: flex;
    justify-content: space-between;
} */
</style>
